import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { ContactForm } from "../components/site/ContactForm";
import { FadeUp } from "../components/site/Motion";
import { WhatsAppIcon, InstagramIcon, FacebookIcon } from "../components/site/Icons";
import { WHATSAPP_URL, WHATSAPP_NUMBER, INSTAGRAM_URL, FACEBOOK_URL, ADDRESS, PHONE } from "../lib/site";

const CHANNELS = [
  { href: WHATSAPP_URL, label: "WhatsApp", sub: WHATSAPP_NUMBER, Icon: WhatsAppIcon, cls: "bg-[#25D366] text-[var(--ink)]" },
  { href: INSTAGRAM_URL, label: "Instagram", sub: "Seguinos", Icon: InstagramIcon, cls: "bg-[var(--ink)] text-white" },
  { href: FACEBOOK_URL, label: "Facebook", sub: "Seguinos", Icon: FacebookIcon, cls: "bg-[var(--forest)] text-white" },
].filter((c) => c.href);

export default function Contacto() {
  return (
    <>
      <PageHero testid="contacto-hero" eyebrow="Contacto" lines={["¿Necesitás ayuda", "con tu viaje?"]} intro="Escribinos y te respondemos a la brevedad. Para algo urgente, usá WhatsApp." />
      <section className="bg-[var(--paper)] pb-24">
        <div className="mx-auto grid max-w-[1400px] gap-6 px-5 md:px-10 lg:grid-cols-12">
          <div className="lg:col-span-7"><ContactForm /></div>
          <div className="flex flex-col gap-4 lg:col-span-5">
            <div data-testid="contact-address-card" className="rounded-[28px] bg-white p-7 ring-1 ring-black/5">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--forest)]">Santiagueño · PuntoEnvío</p>
              <p className="mt-2 font-display text-2xl">{ADDRESS}</p>
              <p className="mt-2 text-[var(--muted-ink)]">Teléfono <a href={`tel:${PHONE}`} className="font-semibold text-[var(--ink)]">{PHONE}</a></p>
            </div>
            {CHANNELS.map(({ href, label, sub, Icon, cls }, i) => (
              <FadeUp key={label} delay={i * 0.08}>
                <a href={href} target="_blank" rel="noopener noreferrer" data-testid={`contact-channel-${label.toLowerCase()}`} className={`group flex items-center justify-between rounded-[28px] p-7 transition-transform duration-500 hover:-translate-y-1 ${cls}`}>
                  <span className="flex items-center gap-5">
                    <Icon className="h-8 w-8" />
                    <span>
                      <span className="block font-display text-2xl">{label}</span>
                      <span className="block text-sm opacity-85">{sub}</span>
                    </span>
                  </span>
                  <ArrowUpRight className="h-6 w-6 transition-transform duration-500 group-hover:rotate-45" />
                </a>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
